import React from "react";
import { Link } from "react-router-dom";
import { Truck, Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, FOOTER_SECTIONS } from "@/lib/company";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-slate-950">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-orange-600">
                <Truck className="h-5 w-5 text-white" />
              </div>
              <span className="text-lg font-black tracking-tight text-white">GO DELIVER</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm text-slate-400">{COMPANY.tagline}</p>
            <div className="mt-5 space-y-2 text-sm text-slate-300">
              <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-orange-400" /> {COMPANY.country}</p>
              <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2 hover:text-orange-300" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-orange-400" /> {COMPANY.phone}
              </a>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 break-all hover:text-orange-300" data-testid="footer-email">
                <Mail className="h-4 w-4 text-orange-400" /> {COMPANY.email}
              </a>
            </div>
          </div>

          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title}>
              <h4 className="text-xs font-mono font-semibold uppercase tracking-[0.18em] text-slate-500">
                {section.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {section.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-slate-300 transition-colors hover:text-orange-400">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved. · {COMPANY.country}</p>
          <p className="flex flex-wrap gap-x-4 gap-y-1">
            <span>Company Name: <span className="text-slate-300">{COMPANY.name}</span></span>
            <span>Phone: <span className="text-slate-300">{COMPANY.phone}</span></span>
            <span>Email: <span className="text-slate-300">{COMPANY.email}</span></span>
          </p>
        </div>
      </div>
    </footer>
  );
};
